import { CInvoicingExchangeRatesType, CInvoicingPriceCurrencyType } from "../types";
import { CInvoicingExchangeRates } from "./CInvoicingExchangeRates";
import { CInvoicingPriceAmount } from "./CInvoicingPrice";

export class CInvoicingPriceCurrency implements CInvoicingPriceCurrencyType {
  constructor(json: CInvoicingPriceCurrencyType) {
    Object.assign(this, json);
  }

  sourceCurrency: string;

  targetCurrency: string;

  price: number;

  toInvoicingPriceAmount = (args: {
    exchangeRates: CInvoicingExchangeRatesType,
  }): CInvoicingPriceAmount => {
    const { exchangeRates } = args;
    const { sourceCurrency, targetCurrency, price } = this;
    if (sourceCurrency !== targetCurrency) {
      const rateToApply = exchangeRates?.rates.find(
        (rate) => rate?.sourceCurrency === sourceCurrency && rate?.targetCurrency === targetCurrency
      );
      const invertedRateToApply = exchangeRates?.rates.find(
        (rate) => rate?.sourceCurrency === targetCurrency && rate?.targetCurrency === sourceCurrency
      );
      if (rateToApply) {
        const conversionFactor = rateToApply?.targetAmount
          ? Number(rateToApply?.targetAmount)
          : undefined;
        return new CInvoicingPriceAmount({
          amount: (conversionFactor ? price * conversionFactor : price) || 0
        });
      }
      if (invertedRateToApply) {
        const conversionFactor = invertedRateToApply?.targetAmount
          ? Number(invertedRateToApply?.targetAmount)
          : undefined;
        return new CInvoicingPriceAmount({
          amount: (conversionFactor ? price * (1 / conversionFactor) : price) || 0,
        });
      }
    }
    return new CInvoicingPriceAmount({
      amount: price,
    });
  };
}
